let prepareTypeInfo = [{
        img: require('../img/prepareSection/attend.png'),
        alt: "Icon of a person behind a screen",
        title: "Attend a Net Impact Event",
        description: "Get to know the club and what Net Impact is all about by attending a Net Impact Info Session or Case Workshop before submitting your application."
    },
    {
        img: require('../img/prepareSection/meet.png'),
        alt: "Icon of 2 chat bubbles",
        title: "Take Initiative, Reach Out!",
        description: "We're tabling during the day from January 20th to January 29th on Sproul. Stop by to ask our members about their experiences and time in NIB or sign up for a coffee chat on the members page!"
    },
    {
        img: require('../img/prepareSection/case.png'),
        alt: "Icon of puzzle pieces",
        title: "Practice Problem Solving",
        description: "Come out to our case coaching workshop to practice casing! Or choose to practice them on your own, if you'd prefer."
    },
    {
        img: require('../img/prepareSection/think.png'),
        alt: "Icon of person thinking",
        title: "Reflect on Past Impact",
        description: "Practice communicating the impact that you’ve made through past projects or in your community."
    }
];

export default prepareTypeInfo;